import { addZero } from '@/helpers/general'

const state = {
  lines: [],
  active: false,
  selected: null,
  tracking: []
}

const mutations = {
  stop: (state) => {
    state.lines = []
    state.tracking = []
    state.selected = null
    state.active = false
  },
  selectDevice: (state, { imei }) => {
    state.selected = imei
  },
  track: (state, { devices }) => {
    if (devices.length === 0) {
      this.$store.commit('Debug/stop')
      return
    }

    state.active = true
    state.tracking = devices

    if (state.selected === null) {
      state.selected = devices[0]
      return
    }

    const stillTracking = devices.find(device => device === state.selected)
    if (!stillTracking) {
      state.selected = devices[0]
    }
  },
  addLine: (state, { imei, line }) => {
    const date = new Date()
    const hours = addZero(date.getHours())
    const minutes = addZero(date.getMinutes())
    const seconds = addZero(date.getSeconds())
    state.lines.push(`<span class="imei">${imei}</span> @ <span class="time">${hours}:${minutes}:${seconds}</span> ${line}`)
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
